import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-depositeschemes',
  templateUrl: './depositeschemes.component.html',
  styleUrls: ['./depositeschemes.component.css']
})
export class DepositeschemesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
